import { takeLatest } from 'redux-saga';
import { put, call, fork, select } from 'redux-saga/effects';
import { fromJS } from 'immutable';
import moment from 'moment';

import { updatePermissionStatus } from '../../utils/jsonapi-functions/campaign-permissions';
import { getUserId } from '../../selectors/user-selectors';
import { getCampaignPermissionsByStatus } from '../../selectors/campaign-permission-selectors';
import { getInfluencerCampaignPermissions } from '../../utils/jsonapi-functions/influencer-campaigns';
import { ARCHIVED, ACTIVE } from '../../utils/static-configuration';
import { reportError } from '../../utils/error-handling-service';

import {
  LOAD_CAMPAIGNS,
  LOAD_CAMPAIGNS_SUCCESS,
  LOAD_CAMPAIGNS_ERROR,
  SET_PERMISSION_STATUS,
  UPDATE_PERMISSION,
  UPDATE_SHOW_CAMPAIGNS_LIST,
} from './constants';

export function* loadCampaigns(actions) {
  try {
    const userId = yield select(getUserId);

    const campaignPermissionsJSON = yield call(getInfluencerCampaignPermissions, userId);
    const campaignPermissions = formatCampaignPermissions(campaignPermissionsJSON);

    const immutableCampaignPermissions = fromJS(campaignPermissions);
    const sortedImmutableCampaignPermissions = immutableCampaignPermissions.sort((campaign1, campaign2) => {
      const d1 = campaign1.getIn(['campaign', 'createdDate']);
      const d2 = campaign2.getIn(['campaign', 'createdDate']);
      if (moment(d1).isBefore(d2)) return 1;
      if (moment(d1).isAfter(d2)) return -1;
      return 0;
    });

    yield put({ type: LOAD_CAMPAIGNS_SUCCESS, campaigns: sortedImmutableCampaignPermissions });
  } catch (error) {
    reportError('LOAD_CAMPAIGNS_LIST_ERROR', error.message);
    yield put({ type: LOAD_CAMPAIGNS_ERROR, error: error.message });
  }
}

function formatCampaignPermissions(campaignPermissions) {
  const campaignPermissionsFormatted = {};
  campaignPermissions.forEach(campaignPermission => {
    campaignPermissionsFormatted[campaignPermission.campaign.id] = campaignPermission;
  });
  return campaignPermissionsFormatted;
}

export function* updateCampaignPermissionStatus(actions) {
  const status = actions.status;
  const permissionId = actions.campaignPermissionId;
  const campaignId = actions.campaignId;

  try {
    yield call(updatePermissionStatus, permissionId, status);
    yield put({ type: UPDATE_PERMISSION, campaignPermissionId: permissionId, campaignId, status });

    const archivedCampaignPermissions = yield select(getCampaignPermissionsByStatus, ARCHIVED);
    if (archivedCampaignPermissions.size === 0) {
      yield put({ type: UPDATE_SHOW_CAMPAIGNS_LIST, campaignPermissionStatus: ACTIVE });
    }
  } catch (error) {
    reportError('UPDATE_CAMPAIGN_PERMISSION_STATUS_ERROR', error.message);
  }
}

export function* watchUpdatePermissionStatus() {
  yield takeLatest(SET_PERMISSION_STATUS, updateCampaignPermissionStatus);
}

export function* watchCampaigns() {
  yield takeLatest(LOAD_CAMPAIGNS, loadCampaigns);
}

export default function* campaignSagas() {
  yield [fork(watchUpdatePermissionStatus), fork(watchCampaigns)];
}



/** WEBPACK FOOTER **
 ** ./src/containers/influencers-campaign-list/sagas.js
 **/